import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { IconWithTooltip } from '../../globalUtils/globalIcons';

interface ICustomDefinePlanButtonProps {
  planMode: string;
  handleClick: (e)=>void;
  editLabel : string;
  defineLabel: string;
  description: string;
}

// eslint-disable-next-line react/prop-types
const CustomDefinePlanButton: React.FC<ICustomDefinePlanButtonProps> = (props) => {
  const { planMode, handleClick,editLabel, defineLabel,description } = props;

  const borderColorGreen = '#00BFBF'
  const borderColorGreen1 = '#27C380'
  const borderColorBlack = '#000';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${borderColorGreen}`, 
        borderRadius: '8px',
        padding: '4px',
        backgroundColor: '#fff',
        width: '329px',
        height:'72px',
        paddingLeft: '20px',
        paddingRight: '20px',
        marginLeft: '4px',
        boxShadow: '0px 4px 10px rgba(73, 200, 209, 0.5)',
        color: borderColorBlack,
      }}
    >
      {/* Tick Mark Icon */}
      <div style={{alignItems:'center',marginRight:'15px'}}>
        <IconWithTooltip iconClassName={planMode !== 'Edit' ?  'define-execution-sidebar': 'execution_plan_button_edit'} />
      </div>

      {/* Text Content */}
      <Box sx={{
        flexGrow: 1,
        alignItems: 'center',
        maxHeight: '60px',
        width: '170px' ,
        overflow: 'hidden',          
        textOverflow: 'ellipsis',    
        whiteSpace: 'normal'
      }}
    >
        
    <Typography
        sx={{
          marginBottom: '4px',
          fontSize: '14px',
          color: planMode === 'Edit' ? borderColorGreen1 : borderColorBlack,
        }}
      >
        {planMode === 'Edit' ? (
            editLabel
        ) : (
          defineLabel
        )
        }
      </Typography>
        {planMode !== 'Edit' && description && (
          <Typography sx={{fontSize:'11px',color:'#8C8C8C',marginTop:'-5px'}}>
            {description}
          </Typography>
        )}
      </Box>

      {/* Pencil Icon on the right */}
      {planMode === 'Edit' && (
        <div   onClick={handleClick}>
          <IconWithTooltip
            iconClassName={'define-execution-edit-pencil-sidebar'} />
        </div>
      )}

      {/* Define/Edit Button */}
      {planMode !== 'Edit' && (
        <Button
          variant='contained'
          sx={{
            backgroundColor: borderColorGreen,
            color: '#fff',
            textTransform: 'none',
            fontWeight: 'bold',
            borderRadius: '6px',
            width: '3px !important',
            '&:hover': {
              backgroundColor:borderColorGreen ,
            },
          }}
          onClick={handleClick}
        >
          <span style={{fontWeight:400,fontSize:'14px'}}>
            Define
          </span>
        </Button>
      )}
    </Box>
  );
};

export default CustomDefinePlanButton;